import * as React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {Button} from '@deviceinsight/ng-ui-basic-components';
import type {AssetGroup, Asset, PaginationSettings} from '@deviceinsight/ng-ui-api-client';
import BulkSelectFilterTable from '../../../../../modules/search/BulkSelectFilterTable';
import type {SearchConfig} from '../../../../../modules/search/types';
import {assetFields} from '../../../../../modules/search/fields';
import columnDefs from '../../../../../modules/search/asset/columnDefs';
import type {AssetWithMetaData} from '../../types';
import {loadGroupDevices} from '../../utils/FloorplanWidgetUtils';
const SEARCH_CONTEXT_UNASSIGNED = 'assetGroupEditUnassignedAssets';
type Props = {
	assetGroup: AssetGroup | null | undefined;
	addedDevices: Array<AssetWithMetaData>;
	onCancelSearch: () => void;
	onAddAssets: (arg0: Array<Asset>) => void;
};
type SelectedState = {
	items?: Array<Asset>;
	count: number;
	query?: string;
	addAll?: boolean;
};
type State = {
	addSelected?: SelectedState | null | undefined;
	removeSelected?: SelectedState | null | undefined;
	modal?: boolean;
	updateTrigger?: any;
	totalElements?: number;
	itemsToSync?: number;
	expectedTotalAfterSync?: number;
};

class AssetSearch extends React.Component<Props, State> {
	state: State = {};
	getSearchConfig = (): SearchConfig<Asset> => {
		const {addedDevices, assetGroup} = this.props;
		return {
			fields: assetFields,
			search: (query, paginationSettings) =>
				loadGroupDevices(query, assetGroup, addedDevices, paginationSettings).then((result) => {
					if (!this.state.modal && query === '') {
						this.setState({
							totalElements: result.totalElements
						});
					}

					return result;
				})
		};
	};
	searchAndAddAll = (query?: string) => {
		const {onAddAssets, assetGroup, addedDevices} = this.props;
		const paginationSettings: PaginationSettings = {
			page: 0,
			size: 1000,
			sort: {
				property: 'name',
				direction: 'ASC'
			}
		};
		loadGroupDevices(query || '', assetGroup, addedDevices, paginationSettings).then((result) => {
			onAddAssets(result.content);
		});
	};

	render() {
		const {onCancelSearch, onAddAssets} = this.props;
		const {addSelected} = this.state;
		return (
			<div>
				<BulkSelectFilterTable
					searchContext={SEARCH_CONTEXT_UNASSIGNED}
					searchConfig={this.getSearchConfig()}
					columnDefinitions={columnDefs()}
					returnEntireItem={true}
					pageSize={5}
					uniqueItemKey={(asset) => asset.id}
					onSelectSome={(items: Array<Asset>) => {
						this.setState({
							addSelected: {
								items,
								count: items.length
							}
						});
					}}
					onSelectAll={(query: string, count: number) => {
						this.setState({
							addSelected: {
								addAll: true,
								count,
								query
							}
						});
					}}
				/>
				<div>
					<Button
						primary
						onClick={() => {
							if (addSelected && addSelected.items) {
								onAddAssets(addSelected.items);
							} else if (addSelected && addSelected.addAll) {
								this.searchAndAddAll(addSelected.query);
							}
						}}
						disabled={!addSelected || addSelected.count === 0}>
						<Trans
							i18nKey="assetSearch.search.addselectedassets"
							values={{
								assetCount: addSelected ? addSelected.count : 0
							}}>
							<>
								Add{' '}
								{{
									assetCount: addSelected ? addSelected.count : 0
								}}{' '}
								assets
							</>
						</Trans>
					</Button>
					<Button onClick={onCancelSearch}>
						<Trans i18nKey="general.actions.cancel">Cancel</Trans>
					</Button>
				</div>
			</div>
		);
	}
}

export default AssetSearch as React.ComponentType<Props>;
